import React from "react";

import { Box, Text } from "@chakra-ui/react";

const MultipleInformation = ({ title, informations, mt }) => {
  return (
    <Box mt={mt ? mt : "15px"} display="block">
      <Text fontWeight={600} fontSize="14px" lineHeight="19.6px" color="#000">
        {title}
      </Text>
      {!!informations && (
        <>
          {informations.map((information, index) => {
            return (
              <Text
                fontWeight={500}
                fontSize="14px"
                lineHeight="19.6px"
                color="#6B6C71"
                key={index}>
                {information}
              </Text>
            );
          })}
        </>
      )}
      {!informations && (
        <Text
          fontWeight={500}
          fontSize="14px"
          lineHeight="19.6px"
          color="#6B6C71">
          Sem informação
        </Text>
      )}
    </Box>
  );
};

export default MultipleInformation;
